<agl-header></agl-header>

<main class="__content" fxLayout="column">
  <router-outlet></router-outlet>
</main>

<agl-footer [footerType]="'b'"></agl-footer>
